import React from "react";
import HeroSection from "../HeroSection";
import HomePageContent from "../HomePageContent";
import Footer from "../Footer";

function Home() {
  return (
    <>
      <HeroSection />
      <HomePageContent />
      <Footer />
    </>
  );
}

export default Home;
